import { Add, Edit, Minus, Trash } from "iconsax-react";
import ConfirmModal from "../../../../component/global/ConfirmModal";

export default function TreeDecorator(props) {
    const { node } = props;
    const toggleHandle = (e) => {
        e.stopPropagation();
        props.onClick();
    };

    const color =
        props.decorators.selectedNode?.id === node?.id ? "white" : "#333";
    return (
        <div
            className={`s-tree-btn ${node.level === 1 ? "blue" : ""} ${
                props.decorators.selectedNode?.id === node?.id ? "selected" : ""
            }`}
            onClick={() => props.decorators.onSelect(node)}
        >
            {(node.children?.length > 0) &&
                (node.toggled ? (
                    <Minus size="18" color={color} onClick={toggleHandle} />
                ) : (
                    <Add size="18" color={color} onClick={toggleHandle} />
                ))}
            <span>{node.name}</span>
            <div>
                <Edit
                    size="18"
                    color={color}
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();

                        props.decorators.functions.editItemType?.(e, node.id);
                    }}
                />
                <Trash
                    size="18"
                    color="red"
                    onClick={(e) =>
                        props.decorators.functions.deleteItemType?.(e, node.id)
                    }
                />
            </div>
        </div>
    );
}
